import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_MAIN_URL,
    // Ayuda a mantener la URL original tras el login
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Crucial para sincronizar sesiones entre múltiples pestañas/ventanas
    storeAuthStateInCookie: true,
  },
  system: {
    // Opcional: aumenta el timeout para evitar errores en redes lentas o IFrames
    iframeHashTimeout: 10000,
  },
});

// --- Lógica de Cuenta Activa ---

// msal-browser 4.x extiende el guard de "hay que llamar a initialize() antes
// que cualquier otra API" a getAllAccounts() también (en 3.x sólo lo tenían
// las llamadas que disparan interacción - ver la nota en index.tsx, Fase 3,
// F3-6). Este archivo se importa (y corre a nivel de módulo) antes de que
// index.tsx llame a msalInstance.initialize(), así que un getAllAccounts()
// acá arriba tira BrowserAuthError("uninitialized_public_client_application")
// de forma síncrona apenas se importa el módulo - reventaba TODA la app.
// Ya no hace falta: index.tsx's initialize().then(handleRedirectPromise) ya
// llama getAllAccounts()/setActiveAccount() correctamente después de
// initialize(), este bloque duplicado quedó de antes de que ese flujo
// existiera (Fase 4, F4-3).

// Escuchamos eventos de éxito para actualizar la cuenta activa automáticamente
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const { account } = payload;
    msalInstance.setActiveAccount(account);
  }
});

// --- Configuración de Requests ---

export const loginRequest = {
  scopes: [process.env.REACT_APP_SCOPE!],
};

/**
 * Función recomendada para obtener el request de token silencioso.
 * Al pasar la 'account' explícitamente, evitamos el error AADSTS160021
 * cuando el usuario tiene múltiples sesiones abiertas.
 */
export const getSilentRequest = () => {
  const activeAccount = msalInstance.getActiveAccount();
  return {
    ...loginRequest,
    account: activeAccount || undefined,
  };
};
